import styled from 'styled-components';
import { Select } from 'antd'

export const ContentOutdateVersion = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`